import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=0b350d55&"
import script from "./SelectProject.vue?vue&type=script&lang=js&"
export * from "./SelectProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports